import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import Flex from 'components/Flex'

export const DriveDetailsHead = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_P_100};
  margin: 0 0 10px 0;
`
export const DriveDetailsViewDiv = styled.div`
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  padding: 15px;
`
export const DreiveDetailFlex = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  padding: 0 0 25px 0;
`
export const CollageNameFlex = styled(Flex)`
  flex-direction: column;
  flex: 1;
  gap: 5px;
  margin-left: 10px;
`
export const CollegeNameDiv = styled.div`
  line-height: 21px;
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  color: ${COLORS.GREY_T_20};
  margin: 0 0 5px 0;
`
export const CollegeCity = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
`
export const DriveInfoFlex = styled(Flex)`
  margin: 25px 20px 0;
`
export const IconSpan = styled.span`
  text-align: center;
  margin-bottom: 3px;
`
export const DriveTypeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.GREY_T_50_2};
  text-align: center;
`
export const DriveNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
  margin-top: 10px;
  text-align: center;
  text-transform: capitalize;
`
export const DriveTypeFlex = styled(Flex)`
  padding: 0 30px 0 0;
  border-right: 1px solid ${COLORS.GREY_T_90};
`
export const DriveStatusFlex = styled(Flex)`
  gap: 10px;
`
export const RolesDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  margin: 20px 0 10px 0;
`
export const RolesInfoDiv = styled.div`
  border: ${props => (props?.border ? props.border : '1px')} solid
    ${COLORS.GREY_T_90};
  height: max-content;
  border-radius: 10px;
  padding: ${props => (props?.padding ? props?.padding : '0 15px')};
  margin: ${props => (props?.margin ? props?.margin : '0')};
`
export const RolesFlex = styled(Flex)`
  padding: ${props => (props?.padding ? props?.padding : '15px 0')};
  border-bottom: ${props => (props?.borderBottom ? props?.borderBottom : '1px')}
    solid ${COLORS.GREY_T_90};
  :last-child {
    border-bottom: none;
  }
`
export const RoleNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
export const RoleCand = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_20};
  background: ${COLORS.GREY_T_95};
  border-radius: 6px;
  padding: 4px 6px;
`
